module.exports = {"data":{"allJavascriptFrontmatter":{"edges":[{"node":{"fields":{"slug":"/contact/"},"frontmatter":{"title":"Contact"}}},{"node":{"fields":{"slug":"/posts/"},"frontmatter":{"title":"Posts"}}},{"node":{"fields":{"slug":"/"},"frontmatter":{"title":"Home"}}}]}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 121
// module chunks = 60335399758886 114276838955818